import { Controller } from "@hotwired/stimulus"
import { Calendar } from "fullcalendar"

export default class extends Controller {
  connect() {
    this.calendar = new Calendar(this.element, {
      initialView: "dayGridMonth",
      headerToolbar: {
        left: "prev,next today",
        center: "title",
        right: "dayGridMonth,timeGridWeek,timeGridDay,listMonth",
      },
    })

    this.calendar.render()
  }

  disconnect() {
    this.calendar?.destroy()
  }
}
